import {
	ReactElement,
	Ref,
	forwardRef
} from "react";
import styles from "./AutogrowTextInput.module.less";
import {
	TextInput,
	TextInputHandle,
	TextInputProps
} from "../TextInput/TextInput";

export type AutogrowTextInputHandle = TextInputHandle;

export type AutogrowTextInputProps = TextInputProps;

export const AutogrowTextInput = forwardRef(
	(props: AutogrowTextInputProps, ref: Ref<AutogrowTextInputHandle>): ReactElement => {
		const {
			value,
			...otherProps
		} = props;

		return (
			<span className={styles.root}>
				<span className={styles.mirror}>{value ?? ""}</span>

				<span className={styles.inputWrapper}>
					<TextInput
						{...otherProps}
						value={value}
						ref={ref}
					/>
				</span>
			</span>
		);
	}
);
AutogrowTextInput.displayName = "AutogrowTextInput";
